'use client'

import { useEffect } from "react"
import Cookies from "js-cookie"
import { useUserStore } from "./useUserStore"

export default function UserStoreInitializer() {
  const { setUser, setProfile, setReseller } = useUserStore()

  useEffect(() => {
    const userId = Cookies.get("userId") ?? null
    const profileId = Cookies.get("profileId") ?? null
    const reseller = Cookies.get("reseller") ?? null


    userId && setUser(userId)
    profileId && setProfile(profileId)
    if (reseller !== null) {
      setReseller(reseller === "true")
    }
  }, [])

  return null
}